const products = [
  {
    category: 'hair',
    id: 'hair',
    name: 'Hair',
    description: 'Hair',
    colors: [[205, 0, 205]],
    strength: 0.7,
  },
  {
    category: 'lipstick',
    id: 'lipstick4',
    name: 'Lipstick',
    description: 'Natural effect',
    colors: [
      [190, 34, 57],
      [126, 1, 31],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.5,
    finish: 'natural',
    finishStrength: 0.4,
  },
  {
    category: 'lipstick',
    id: 'lipstick1',
    name: 'Lipstick',
    description: 'Gloss effect',
    colors: [
      [184, 15, 10],
      [126, 1, 31],
      [255, 8, 0],
      [204, 67, 133],
      [222, 93, 131],
      [254, 176, 189],
      [254, 40, 162],
    ],
    strength: 0.4,
    finish: 'gloss',
    finishStrength: 0.8,
  },
  {
    category: 'lipstick',
    id: 'lipstick2',
    name: 'Lipstick',
    description: 'Matte effect',
    colors: [
      [190, 34, 57],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
    ],
    strength: 0.5,
    finish: 'matte',
    finishStrength: 0.5,
  },
  {
    category: 'lipstick',
    id: 'lipstick3',
    name: 'Lipstick',
    description: 'Metallic effect',
    colors: [
      [190, 34, 57],
      [126, 1, 31],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.5,
    finish: 'metallic',
    finishStrength: 0.7,
  },

  {
    category: 'lipstick',
    id: 'lipstick5',
    name: 'Lipstick',
    description: 'Frost effect',
    colors: [
      [190, 34, 57],
      [126, 1, 31],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.5,
    finish: 'frost',
    finishStrength: 0.7,
  },
  {
    category: 'lipstick',
    id: 'lipstick7',
    name: 'Lipstick',
    description: 'Satin effect',
    colors: [
      [190, 34, 57],
      [126, 1, 31],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.5,
    finish: 'satin',
    finishStrength: 0.7,
  },
  {
    category: 'lipliner',
    id: 'lipliner1',
    name: 'Lipliner',
    description: 'Low coverage',
    colors: [
      [190, 34, 57],
      [254, 76, 64],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.4,
  },
  {
    category: 'lipliner',
    id: 'lipliner2',
    name: 'Lipliner',
    description: 'Medium coverage',
    colors: [
      [190, 34, 57],
      [254, 76, 64],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.6,
  },
  {
    category: 'lipliner',
    id: 'lipliner3',
    name: 'Lipliner',
    description: 'Full coverage',
    colors: [
      [190, 34, 57],
      [254, 76, 64],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 1,
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow1',
    name: 'Eyeshadow',
    description: 'Single color with matte finish',
    image: 'solid',
    colors: [
      [190, 34, 57],
      [254, 76, 64],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
      [207, 143, 105],
      [101, 53, 14],
    ],
    strength: 0.5,
    type: 'variant1',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow2',
    name: 'Eyeshadow',
    description: 'Color palette variant 1 with matte finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant1',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow3',
    name: 'Eyeshadow',
    description: 'Color palette variant 2 with matte finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant2',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow4',
    name: 'Eyeshadow',
    description: 'Color palette variant 3 with matte finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant3',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow5',
    name: 'Eyeshadow',
    description: 'Color palette variant 4 with matte finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.55,
    type: 'variant4',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow6',
    name: 'Eyeshadow',
    description: 'Color palette variant 8 with matte finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.5,
    type: 'variant8',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow7',
    name: 'Eyeshadow',
    description: 'Color palette variant 1 with glitter finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant1',
    finish: 'glitter',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow8',
    name: 'Eyeshadow',
    description: 'Color palette variant 1 with shimmer finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant1',
    finish: 'shimmer',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow9',
    name: 'Eyeshadow',
    description: 'Color palette variant 1 with frost finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant1',
    finish: 'frost',
  },
  {
    category: 'eyeshadow',
    id: 'eyeshadow10',
    name: 'Eyeshadow',
    description: 'Color palette variant 1 with metallic finish',
    image: 'palette',
    colors: [
      [
        [255, 255, 255],
        [100, 100, 100],
        [0, 0, 0],
      ],
      [
        [253, 199, 168],
        [248, 158, 120],
        [160, 63, 46],
      ],
      [
        [255, 255, 255],
        [69, 106, 90],
        [3, 49, 60],
      ],
      [
        [235, 211, 199],
        [242, 156, 191],
        [149, 64, 110],
      ],
      [
        [99, 201, 188],
        [67, 154, 146],
        [114, 70, 123],
      ],
    ],
    strength: 0.6,
    type: 'variant1',
    finish: 'metallic',
  },
  {
    category: 'eyeliner',
    id: 'eyeliner1',
    name: 'Eyeliner',
    description: 'Classic eyeliner',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [26, 72, 118],
    ],
    strength: 0.6,
    type: 'classic',
  },
  {
    category: 'eyeliner',
    id: 'eyeliner2',
    name: 'Eyeliner',
    description: 'Everyday eyeliner',
    colors: [
      [7, 0, 8],
      [26, 72, 118],
      [43, 21, 3],
      [114, 49, 87],
    ],
    strength: 0.6,
    type: 'everyday',
  },
  {
    category: 'eyeliner',
    id: 'eyeliner3',
    name: 'Eyeliner',
    description: 'Light eyeliner',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [26, 72, 118],
      [190, 34, 57],
      [126, 1, 31],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.7,
    type: 'light',
  },
  {
    category: 'eyeliner',
    id: 'eyeliner4',
    name: 'Eyeliner',
    description: 'Top eyeliner',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [26, 72, 118],
      [190, 34, 57],
      [126, 1, 31],
      [222, 93, 131],
      [157, 68, 110],
      [193, 78, 38],
      [128, 0, 128],
    ],
    strength: 0.7,
    type: 'top',
  },
  {
    category: 'blush',
    id: 'blush1',
    name: 'Blush',
    description: 'C-Shape',
    colors: [
      [190, 34, 57],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
    ],
    strength: 0.4,
    type: 'cShape',
  },
  {
    category: 'blush',
    id: 'blush2',
    name: 'Blush',
    description: 'Oval face',
    colors: [
      [190, 34, 57],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
    ],
    strength: 0.4,
    type: 'oval',
  },
  {
    category: 'blush',
    id: 'blush3',
    name: 'Blush',
    description: 'Square face',
    colors: [
      [190, 34, 57],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
    ],
    strength: 0.4,
    type: 'square',
  },
  {
    category: 'blush',
    id: 'blush4',
    name: 'Blush',
    description: 'Triangle face',
    colors: [
      [190, 34, 57],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
    ],
    strength: 0.4,
    type: 'triangle',
  },
  {
    category: 'blush',
    id: 'blush5',
    name: 'Blush',
    description: 'Lift',
    colors: [
      [190, 34, 57],
      [204, 67, 133],
      [222, 93, 131],
      [157, 68, 110],
    ],
    strength: 0.4,
    type: 'lift',
  },
  {
    category: 'highlighter',
    id: 'highlighter3',
    name: 'Positive Light Liquid Luminizer Highlight',
    description: 'Natural',
    colors: [
      [232, 188, 149],
      [250, 183, 141],
      [136, 60, 24],
    ],
    coverage: 0.9,
    finishStrength: 0.7,
    finish: 'natural',
  },
  {
    category: 'highlighter',
    id: 'highlighter2',
    name: 'Positive Light Liquid Luminizer Highlight',
    description: 'Shimmer',
    colors: [
      [249, 196, 145],
      [232, 188, 149],
      [136, 60, 24],
    ],
    coverage: 0.9,
    finishStrength: 0.7,
    finish: 'shimmer',
  },
  {
    category: 'highlighter',
    id: 'highlighter1',
    name: 'Positive Light Liquid Luminizer Highlight',
    description: 'Mettalic',
    colors: [
      [249, 196, 145],
      [232, 188, 149],
      [136, 60, 24],
    ],
    coverage: 0.9,
    finishStrength: 0.7,
    finish: 'metallic',
  },
  {
    category: 'concealer',
    id: 'concealer3',
    name: 'Radiant Creamy Concealer',
    description: 'Medium coverage',
    colors: [
      [249, 196, 145],
      [232, 188, 149],
      [250, 183, 141],
    ],
    coverage: 0.7,
  },
  {
    category: 'concealer',
    id: 'concealer2',
    name: 'Radiant Creamy Concealer',
    description: 'Medium coverage',
    colors: [
      [128, 68, 42],
      [156, 91, 53],
      [177, 108, 77],
    ],
    coverage: 0.7,
  },
  {
    category: 'concealer',
    id: 'concealer1',
    name: 'Radiant Creamy Concealer',
    description: 'Medium coverage',
    colors: [
      [252, 212, 187],
      [242, 208, 180],
      [221, 202, 170],
    ],
    coverage: 0.7,
  },
  {
    category: 'bronzer',
    id: 'bronzer6',
    name: 'Airbrush Matte Bronzer',
    description: 'Square',
    colors: [
      [213, 164, 129],
      [181, 125, 91],
      [172, 108, 73],
      [123, 67, 45],
    ],
    coverage: 0.5,
    finish: 'matte',
    type: 'square',
  },
  {
    category: 'bronzer',
    id: 'bronzer5',
    name: 'Airbrush Matte Bronzer',
    description: 'Round',
    colors: [
      [213, 164, 129],
      [181, 125, 91],
      [172, 108, 73],
      [123, 67, 45],
    ],
    coverage: 0.5,
    finish: 'matte',
    type: 'round',
  },
  {
    category: 'bronzer',
    id: 'bronzer4',
    name: 'Airbrush Matte Bronzer',
    description: 'Long',
    colors: [
      [213, 164, 129],
      [181, 125, 91],
      [172, 108, 73],
      [123, 67, 45],
    ],
    coverage: 0.5,
    finish: 'matte',
    type: 'Long',
  },
  {
    category: 'bronzer',
    id: 'bronzer3',
    name: 'Airbrush Matte Bronzer',
    description: 'Oval',
    colors: [
      [213, 164, 129],
      [181, 125, 91],
      [172, 108, 73],
      [123, 67, 45],
    ],
    coverage: 0.6,
    finish: 'matte',
    type: 'Oval',
  },
  {
    category: 'bronzer',
    id: 'bronzer2',
    name: 'Match Skix Contour Skinstick',
    description: 'Diamond',
    colors: [
      [213, 164, 129],
      [181, 125, 91],
      [172, 108, 73],
      [114, 73, 57],
    ],
    coverage: 0.5,
    finish: 'matte',
    type: 'diamond',
  },
  {
    category: 'bronzer',
    id: 'bronzer1',
    name: 'Hoola Bronzer',
    description: 'Heart',
    colors: [
      [213, 164, 129],
      [181, 125, 91],
      [172, 108, 73],
      [123, 67, 45],
    ],
    coverage: 0.6,
    finish: 'matte',
    type: 'heart',
  },
  {
    category: 'foundation',
    id: 'foundation3',
    name: 'Foundation',
    description: 'Light coverage',
    colors: [
      [209, 175, 154],
      [195, 150, 130],
      [144, 107, 77],
      [92, 62, 46],
      [60, 39, 8],
      [43, 24, 5],
    ],
    coverage: 0.5,
  },
  {
    category: 'foundation',
    id: 'foundation2',
    name: 'Foundation',
    description: 'Medium coverage',
    colors: [
      [209, 175, 154],
      [195, 150, 130],
      [144, 107, 77],
      [92, 62, 46],
      [60, 39, 8],
      [43, 24, 5],
    ],
    coverage: 0.7,
  },
  {
    category: 'foundation',
    id: 'foundation1',
    name: 'Foundation',
    description: 'Full coverage',
    colors: [
      [209, 175, 154],
      [195, 150, 130],
      [144, 107, 77],
      [92, 62, 46],
      [60, 39, 8],
      [43, 24, 5],
    ],
    coverage: 0.9,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow5',
    name: 'Just color',
    image: 5,
    description: 'Color without arc or height transform',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: 0.01,
    arc: 0.01,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow6',
    name: 'Low arc',
    image: 6,
    description: 'Low arc transform',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: 0.01,
    arc: -0.5,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow7',
    name: 'Narrow transform',
    image: 8,
    description: 'Narrow eyebrow transform',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: -1,
    arc: 0.01,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow8',
    name: 'Wide transform',
    image: 7,
    description: 'Wide eyebrow transform',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: 1,
    arc: 0.01,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow1',
    name: 'Narrow and low',
    image: 1,
    description: 'narrow with low arc',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: -1,
    arc: -0.5,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow2',
    name: 'Narrow and high',
    image: 2,
    description: 'narrow with high arc',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: -1,
    arc: 0.5,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow3',
    name: 'Wide and low',
    image: 3,
    description: 'wide with low arc',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: 0.3,
    arc: -0.3,
  },
  {
    category: 'eyebrows',
    id: 'eyebrow4',
    name: 'Wide and high',
    image: 4,
    description: 'wide with high arc',
    colors: [
      [43, 21, 3],
      [101, 53, 14],
      [207, 143, 105],
    ],
    strength: 0.4,
    height: 0.3,
    arc: 0.5,
  },
  {
    category: 'mascara',
    id: 'mascara1',
    name: 'Mascara',
    description: 'Volume effect',
    colors: [
      [0, 0, 0],
      [14, 105, 160],
      [57, 4, 117],
    ],
    strength: 0.7,
    type: 'volume',
  },
  {
    category: 'mascara',
    id: 'mascara2',
    name: 'Mascara',
    description: 'Fake lashes effect',
    colors: [
      [0, 0, 0],
      [14, 105, 160],
      [57, 4, 117],
    ],
    strength: 0.7,
    type: 'fake',
  },
  {
    category: 'mascara',
    id: 'mascara3',
    name: 'Mascara',
    description: 'False lashes effect',
    colors: [
      [0, 0, 0],
      [14, 105, 160],
      [57, 4, 117],
    ],
    strength: 0.7,
    type: 'false',
  },
];

export default products;
